/**
 * AssignDevicesCtrl controller
 * Show devices for subscriber and available devices
 */

import { add, remove } from 'app/helpers/entity'

// controller mixins
AssignDevicesCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * AssignDevicesCtrl controller
 *
 * @class AssignDevicesCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AssignDevicesCtrl
 */
/* @ngInject */
export default function AssignDevicesCtrl (Device, authSvc, subscr, extra) {
  var vm = this
  vm.subscr = subscr

  /**
   * Extra
   *
   * @memberof mwApp/subscribers.controller:AssignDevicesCtrl
   * @type {Object}
   */
  vm.extra = extra

  // assigned devices
  vm.assignedDevices = subscr.devices

  // available devices
  vm.availableDevices = extra.devices.slice(0, 20)

  vm.selectSearch = ''
  vm.$timer = 0
  vm.openCount = 0

  /**
   * Filter channels, it seems that this works faster, then filter in ui-select-choices
   *
   * @param  {Object} $select
   */
  vm.refreshDevices = function ($select = {}) {
    let search = $select.search || ''

    search = search ? search.toLowerCase() : null
    vm.openCount = $select.open ? vm.openCount + 1 : 0

    if (vm.openCount > 1) {
      vm.selectSearch = $select.search
    }

    if (vm.openCount === 1) {
      $select.search = vm.selectSearch
    }

    if ($select.open) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        subscr._searchDevices(search)
          .data()
          .then((devices) => {
            vm.availableDevices = Device.cast(devices, ['Device'])
          })
      }, 700)
    }
  }

  // nullify selected device
  function cleanSelectedDevice () {
    vm.selectedDevice = null

    // fastfix for devices count
    extra.deviceCount = vm.assignedDevices.length

    // refresh devices in dropdown list
    vm.refreshDevices()
  }

  // assign selected device to subscriber
  vm.assign = function (device) {
    if (device) {
      device._assign(subscr.id)
        .then(remove(extra.devices)(device))
        .then(add(vm.assignedDevices)(device))
        .then(cleanSelectedDevice)
        .then(function () { device.enabled = true }) // enable device (just flag in model)
    }
  }

  // unassign device from subscriber
  vm.unassign = function (device) {
    if (device) {
      device._unassign()
        .then(remove(vm.assignedDevices)(device))
        .then(add(extra.devices)(device))
        .then(cleanSelectedDevice)
    }
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }
}
